module.exports = __webpack_public_path__ + "static/media/guanyu.abeccf59.jpg";